// extracted by mini-css-extract-plugin
export default {"container":"CardsContainer_container__l1-8E"};